<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <g clip-path="url(#chevron-right__a)">
    <path d="M5.209 2.265a1 1 0 0 0 0 1.416L13.543 12l-8.334 8.32a1 1 0 0 0 0 1.415l1.563 1.56a1 1 0 0 0 1.413 0l10.606-10.587a1 1 0 0 0 0-1.416L8.185.705a1 1 0 0 0-1.413 0l-1.563 1.56Z"/>
  </g>
  <defs>
    <clipPath id="chevron-right__a">
      <path d="M0 0h24v24H0z"/>
    </clipPath>
  </defs>
</svg>
